import React from "react"
import { Text } from "@rebass/emotion"

export default function Section({ ...props }) {
  return <Text as="section" pb={150} {...props} width={[1]} />
}
